<div *ngIf="upstream_screen">
<h3>{{'upstream' | titleText }}</h3>
 
<div  class="card">
    <div>
        <input type="text" placeholder="Enter FJL ID for new SPL installation" id="fjl_Id" name="fjlId" required (change)="inputOnChange($event)"/>
        <select (change)="onfjlSPLChange($event)">
        <option value="">Select FJL Splitter type :</option><option value="1:2">SPLITTER_1:2</option></select>
        <button (click)="fjladdSPL()">Add New FJL-SPL</button>
    </div> 
    
    <app-table 
        [inputData]="inputData"
        (appItemEvent)="receiveTableEventUpstream($event)" >
    </app-table>
</div>

</div>

<div *ngIf="select_smp_screen">
    <app-select-smp-hd
        [inputData]="inputData"
    ></app-select-smp-hd>
</div>

<!-- spinner Component Called-->
<div *ngIf="isLoading">
  <ngx-spinner type = "ball-scale-multiple"></ngx-spinner> 
</div>